Vgr.dtoMappings = {
	measureUnit: {
		// O Core serializa o grupo como nome do enum; o portal compara com os valores numéricos do antigo api/v1/measure-units
		legacyGroupByCoreGroup: {
			Volume: 1,
			Mass: 2,
			Unit: 3,
			Power: 4,
			Distance: 5
		},
		fromCoreToV2: function (measureUnitCore) {
			return {
				Id: measureUnitCore.id,
				Name: measureUnitCore.description,
				Abbreviation: measureUnitCore.abbreviation,
				Group: Vgr.dtoMappings.measureUnit.legacyGroupByCoreGroup[measureUnitCore.group],
				ConversionFactor: measureUnitCore.conversionFactorToDefaultMeasureUnitFromGroup
			};
		}
	},
	residue: {
		// Id é o numérico (CODIGO_RESIDUO) que a API de destinações espera; ResidueId é o Guid
		fromResiduesToV2: function (residue, organizationUnitRecipientIdByRecipientId) {
			const organizationUnitRecipientId = residue.recipientId
				? organizationUnitRecipientIdByRecipientId[residue.recipientId]
				: null;

			return {
				Id: residue.legacyId,
				ResidueId: residue.id,
				Code: residue.code,
				Name: residue.name,
				Active: residue.active,
				Dangerous: !!residue.residueClass?.isDangerous,
				DefaultDisposalId: residue.defaultDisposalTypeId ?? null,
				GeneralResidueName: residue.systemResidue?.name ?? null,
				MinimumQuantity: residue.minimumDisposalQuantity ?? null,
				MaximumQuantity: residue.maximumDisposalQuantity ?? null,
				MeasureUnit: residue.measureUnit ? Vgr.dtoMappings.measureUnit.fromCoreToV2(residue.measureUnit) : null,
				Recipient: organizationUnitRecipientId != null ? { Id: organizationUnitRecipientId } : null
			};
		}
	},
	organizationUnit: {
		fromCoreToContext: function (organizationUnitCoreDto) {
			const dto = {
				id: organizationUnitCoreDto.id,
				code: organizationUnitCoreDto.code,
				name: organizationUnitCoreDto.name,
				active: organizationUnitCoreDto.active,
				city: {},
				latitude: organizationUnitCoreDto.latitude,
				longitude: organizationUnitCoreDto.longitude,
				registerCompleted: organizationUnitCoreDto.registerCompleted,
				document: organizationUnitCoreDto.document,

				decimalPlaces: organizationUnitCoreDto.organization.decimalPlaces,
				priceDecimalPlaces: organizationUnitCoreDto.organization.priceDecimalPlaces,
				organization: {
					id: organizationUnitCoreDto.organization.id,
					name: organizationUnitCoreDto.organization.name,
					features: organizationUnitCoreDto.organization.features
				}
			};

			if (organizationUnitCoreDto.city) {
				dto.city = {
					id: organizationUnitCoreDto.city.Id,
					description: organizationUnitCoreDto.city.name,
					state: {
						id: organizationUnitCoreDto.city.state.id,
						description: organizationUnitCoreDto.city.state.name,
						countryId: organizationUnitCoreDto.city.state.countryId
					}
				};
			}

			return dto;
		}
	}
};
